import { formatDate } from '@angular/common';
import { getPmsDateFormat, getPmsLocale, PmsDateToken } from './pms-date-locale.util';

type PmsDateInput = Date | string | number | null | undefined;

export function formatPmsDate(value: PmsDateInput, token: PmsDateToken = 'shortDate', fallback = ''): string {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  try {
    return formatDate(value, getPmsDateFormat(token), getPmsLocale());
  } catch {
    return fallback;
  }
}
